import { confirm } from 'components/modals/confirm'

export function useConfirmRemoverGrupo() {
  return (): Promise<boolean> => {
    return confirm({
      title: 'Deseja remover o grupo do registro?',
      body:
        'Ao remover este grupo da atividade todos os profissionais e cidadãos participantes associados serão automaticamente removidos do registro em andamento.',
      confirmLabel: 'Remover',
      type: 'danger',
    })()
  }
}
